import { iqHint, type SubmissionListItem } from '@jfh/intake-shared';

/**
 * The Needs fixing page's rows (F10 P5): one per problem — an application
 * whose iQ call failed, or whose Teams card didn't post — saying what didn't
 * happen, what to do, and the system's own words.
 */

export interface Problem {
  key: string;
  kind: 'iq' | 'teams';
  sub: SubmissionListItem;
  /** "Customer not set up." */
  what: string;
  hint: string;
  /** "iQ said: …" / "Teams said: …" */
  said: string;
  at: string;
}

export function iqWhat(sub: SubmissionListItem): string {
  if (sub.type === 'lead') return 'Lead not created.';
  if (sub.iq?.op === 'update') return 'Credit terms not added.';
  if (sub.type === 'supplier_account') return 'Supplier not set up.';
  return 'Customer not set up.';
}

export function problems(items: SubmissionListItem[]): Problem[] {
  const out: Problem[] = [];
  for (const sub of items) {
    if (sub.iq && !sub.iq.ok && !sub.iq.stubbed) {
      out.push({
        key: `${sub.id}:iq`,
        kind: 'iq',
        sub,
        what: iqWhat(sub),
        hint: iqHint(sub.iq.message),
        said: sub.iq.message ? `iQ said: ${sub.iq.message}` : `iQ didn’t say why (status ${sub.iq.iqStatus ?? sub.iq.httpStatus ?? 'unknown'}).`,
        at: sub.iq.at,
      });
    }
    if (sub.teamsCardError) {
      out.push({
        key: `${sub.id}:teams`,
        kind: 'teams',
        sub,
        what: 'Teams card didn’t post.',
        hint: 'JFH Forms tries again every hour. You can resend it now, or decide in JFH Forms instead.',
        said: `Teams said: ${sub.teamsCardError}`,
        at: sub.teamsCardAt ?? sub.updatedAt,
      });
    }
  }
  return out.sort((a, b) => b.at.localeCompare(a.at));
}
